import { render, staticRenderFns } from "./MyForm.vue?vue&type=template&id=4f006a34&scoped=true&"
import script from "./MyForm.vue?vue&type=script&lang=js&"
export * from "./MyForm.vue?vue&type=script&lang=js&"
import style0 from "./MyForm.vue?vue&type=style&index=0&id=4f006a34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f006a34",
  null
  
)

export default component.exports